export default {
  TITLE: 'Service settings',
  DESCRIPTION: 'Loading your service settings...'
};
